<template>
  <div>
    <div class="columns upload-wrapper">
      <div class="column is-4">
        <form-component
          v-for="formDescriptor in formDescriptors"
          :formDescriptor="formDescriptor"
          :formData="getFormDataForDescriptor(formDescriptor)"
          :key="formDescriptor.id">
        </form-component>
      </div>
      <div class="column is-3">
        <button class="button is-success" @click="saveMessage()"
          v-translate>
          Save file
        </button>
      </div>
    </div>
    <table-component-buefy
      v-if="mixin.loaded"
      :hide_table_search="true"
      :content="messages"
      :headings="table_headings"
      :item_keys="table_keys"
      :display_spec="messageSpecs"
      :total_items="mixin.total_items"
      :pagination_callback="mixin.loadItems">
    </table-component-buefy>
    <!-- Loader -->
  <loader-component v-else></loader-component>
  </div>
</template>
<script>
  import { mapActions, mapState } from 'vuex'
  import { messageSpecs } from '@/display_context/display_context'
  import { loadItemsMixin, formHandlerMixin } from '@/mixins/mixins'
  import TableComponentBuefy from '@/components/layout/table/TableComponentBuefy'
  import FormComponent from '@/components/form/FormComponent'
  import LoaderComponent from '@/components/layout/utility/LoaderComponent'

  export default {
    name: 'case-message-view',
    mixins: [formHandlerMixin, loadItemsMixin],
    components: {
      FormComponent,
      LoaderComponent,
      TableComponentBuefy
    },
    data () {
      return {
        table_headings: ['To', 'From', 'Subject', 'Message', 'Date', 'Attachments'],
        table_keys: ['receiver', 'sender', 'subject', 'content', 'date', 'filesComponent'],
        messageSpecs: messageSpecs,
        mixin: {
          actionMethod: this.getMessages,
          actionParams: { case: this.caseId }
        }
      }
    },
    props: {
      caseId: {
        required: true
      }
    },
    computed: {
      ...mapState({
        messages: state => state.customerModule.emailMessages,
        formDescriptors: state => state.customerModule.messageFormDescriptor,
        formDatas: state => state.customerModule.messageFormData
      })
    },
    methods: {
      ...mapActions([
        'getMessages',
        'getMessageForm',
        'saveMessageForm',
        'successMessage'
      ]),
      createRequestData (formDatas) {
        return {
          caseId: this.caseId,
          formDatas: formDatas,
          submitRequest: null
        }
      },
      saveMessage () {
        let requestData = this.createRequestData(this.formDatas)
        this.submitRequest = this.saveMessageForm
        this.validateForm(requestData).then((response) => {
          this.saveMessageCallback(response)
        }).catch((err) => {
          if (this.showErrorMessage(err)) {
            return
          }
          this.handleError(err)
        })
      },
      saveMessageCallback (response) {
        this.successMessage('MSG uploaded successfully!')
        let callbacks = [this.getMessages]
        this.setOrRefreshItem('case', this.caseId, callbacks)
      }
    },
    mounted () {
      this.getMessageForm(this.caseId).catch((err) => {
        this.handleError(err)
      })
    }
  }
</script>

<style lang="sass" scoped>
  .upload-wrapper
    .form-component
      margin-top: 0px
    .button
      margin-top: 25px

</style>
